import { Api } from "../config/request";

export default {
  getZoneList(queryParams) {
    return Api.get(
      `/locations/zones${
        queryParams && queryParams.length > 0 ? `?${queryParams}` : ""
      }`
    );
  },
  getZone(payload) {
    const id = payload.id;
    return Api.get(`/locations/zones/${id}`);
  },
};
